import { Link } from "react-router-dom";
import PageShell from "./_page-shell";

export default function HelpPage() {
  return (
    <PageShell
      title="Aide projet web"
      subtitle="Besoin d'aide ? Contactez-moi via le formulaire pour votre creation de site web."
    >
      <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-6">
        <h2 className="text-lg font-semibold text-white">Comment obtenir une reponse rapide ?</h2>
        <p className="text-sm leading-relaxed text-white/70">
          Pour une réponse rapide, décrivez votre demande dans la section Contact
          de la page d’accueil.
        </p>
        <a
          href="/#contact"
          className="mt-4 inline-flex items-center justify-center rounded-xl border border-white/15 bg-white/[0.03] px-5 py-3 text-sm font-semibold text-white hover:bg-white/[0.06]"
        >
          Aller au formulaire de contact
        </a>
        <p className="mt-4 text-sm text-zinc-500">
          Vous pouvez aussi consulter la <Link to="/faqs">FAQ</Link> ou voir mes{" "}
          <Link to="/#projects">realisations</Link>.
        </p>
      </div>
    </PageShell>
  );
}

